import { render, staticRenderFns } from "./PersistOcorrenciaTrackingView.vue?vue&type=template&id=340ea797&"
import script from "./PersistOcorrenciaTrackingView.vue?vue&type=script&lang=ts&"
export * from "./PersistOcorrenciaTrackingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports